/**
 * Survey item types which are available in Impact.
 */
export default {
  TEXT: 'text',
  LONG_TEXT: 'long_text',
  EMAIL: 'email',
  LABEL: 'label',
  NUMERIC: 'numeric',
  DATE: 'date',
  TIME: 'time',
  DURATION: 'duration',
  POSTCODE: 'postcode',
  SINGLE_CHECKBOX: 'single_checkbox',
  CHECKBOXES: 'checkboxes',
  DROP_DOWN: 'drop_down',
  MULTIPLE_CHOICE: 'multiple_choice',
  MULTIPLE_CHOICE_GRID: 'multi_choice_grid',
  LINEAR_SCALE: 'linear_scale',
  THERMOMETER: 'thermometer',
  WELLBEING_SCALE: 'wellbeing_scale'
}
